
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'

import { mapState, mapMutations, mapActions } from 'vuex'
import { register } from 'register-service-worker'

function canShowInstallPrompt() {
const installData = JSON.parse(localStorage.getItem('pwaInstallPromptData'));
if (!installData)
return true;

const { lastShown, count } = installData;
const today = new Date().toDateString();

if (count >= 5) {

return false;
}

if (lastShown === today) {

return false;
}

return true;
}

function updateInstallPromptData() {
const today = new Date().toDateString();
const installData = JSON.parse(localStorage.getItem('pwaInstallPromptData')) || { lastShown: null, count: 0 };

if (installData.lastShown !== today) {
installData.lastShown = today;
installData.count += 1;
localStorage.setItem('pwaInstallPromptData', JSON.stringify(installData));
}
}

export default {
components: {
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Drawer,
},
data: function () {
return {
showHeader: true,
drawerOpen: false,
}
},
computed: {
...mapState('settings', ['language', 'configIndex']),
...mapState('ai', ['messages']),
route() {
return this.$route
},
},
methods: {
...mapMutations('settings', ['setValue']),
...mapActions('ai', ['initEngine']),
...mapActions('settings', ['readCookies']),
...mapActions(['getBrowserCapabilities']),
showMessages: function () {
this.drawerOpen = !this.drawerOpen
},
},
watch: {
language(newValue) {
this.$i18n.locale = newValue
},
},
created() {
this.getBrowserCapabilities()
this.readCookies()
if (!this.language) {
this.setValue({ key: 'language', value: this.$i18n.locale })
} else {
this.$i18n.locale = this.language
}
},
mounted() {
const _this = this

this.$vux.alert.show_i18n = function (options) {
options.buttonText = _this.$t('common.ok')
_this.$vux.alert.show(options)
}
this.$vux.confirm.show_i18n = function (options) {
options.confirmText = _this.$t('common.confirm')
options.cancelText = _this.$t('common.cancel')
_this.$vux.confirm.show(options)
}
this.$vux.confirm.prompt_i18n = function (value, options) {
options.confirmText = _this.$t('common.confirm')
options.cancelText = _this.$t('common.cancel')
_this.$vux.confirm.prompt(value, options)
}

window.onresize = function () {

_this.$store.commit('setScreenSize', {
width: document.documentElement.clientWidth,
height: document.documentElement.clientHeight,
})
}

const loadEngine = (loadFullEngine) => {
_this.initEngine(loadFullEngine).catch((err) => {
_this.$vux.alert.show_i18n({
title: _this.$t('game.engineLoadingError'),
content: err.toString(),
})
})
}


if ('serviceWorker' in navigator) {
register(`${process.env.BASE_URL}service-worker.js`, {
ready() {
console.log(
'App is being served from cache by a service worker.\n' +
'For more details, visit https://goo.gl/AFskqB'
)
loadEngine(true)
},
updated() {
_this.$vux.confirm.show_i18n({
title: _this.$t('update.title'),
content: _this.$t('update.msg'),
onConfirm() {
location.reload()
},
onCancel() { }
})
},
error(error) {
console.error('Error during service worker registration:', error)
}
})

window.addEventListener('beforeinstallprompt', (e) => {
if (!canShowInstallPrompt()) {

return;
}


e.preventDefault();

const deferredPrompt = e;

_this.$vux.confirm.show_i18n({
title: _this.$t('install.title'),
content: _this.$t('install.msg'),
onConfirm() {

updateInstallPromptData();

deferredPrompt.prompt();
},
onCancel() {
updateInstallPromptData();
}
});
});
} else {
if (this.configIndex == 0)
this.setValue({ key: 'configIndex', value: 1 })
loadEngine(false)
}
},
}
